import { createFileRoute } from "@tanstack/react-router";
import PrivateSellLanding from "@/pages/PrivateSellLanding";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/vinde-masina/")({
  head: () => routeHead("/uk/vinde-masina/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PrivateSellLanding />
  );
}
